import { Auth } from "@aws-amplify/auth";

import { useCallback, useContext, useMemo, useState } from "react";

import UserInfoContext from "@/context/UserInfoContext";
import { UserInfo } from "@/typings";

import useEvent from "./useEvent";

const useUserInfo = () => {
  const [userInfo, setUserInfo] = useState<UserInfo>();

  const handleSetUserInfo = useCallback((data?: UserInfo) => {
    setUserInfo(data);

    if (data?.token) {
      localStorage.setItem("jwtToken", data.token);
    } else {
      localStorage.removeItem("jwtToken");
    }
  }, []);

  const userInfoContextValue = useMemo(() => {
    return {
      userInfo,
      setUserInfo: handleSetUserInfo,
    };
  }, [userInfo, handleSetUserInfo]);

  const userInfoContext = useContext(UserInfoContext);

  const getUserInfo = useCallback(async () => {
    if (userInfoContext.userInfo) {
      return userInfoContext.userInfo;
    } else {
      try {
        const res = await Auth.currentAuthenticatedUser();

        const userInfo = {
          email: res.attributes.email,
          token: res.signInUserSession.idToken.jwtToken,
          profile_img: res.attributes?.picture,
        };

        userInfoContext.setUserInfo(userInfo);

        return userInfo;
      } catch (error) {
        // userInfoContext.setUserInfo(undefined);

        return {
          token: "",
        };
      }
    }
  }, [userInfoContext]);

  const userInfoContextInit = useEvent((cb: () => void) => {
    Auth.currentAuthenticatedUser()
      .then((user) => {
        if (user) {
          const userInfo = {
            email: user.attributes.email,
            token: user.signInUserSession.idToken.jwtToken,
            profile_img: user.attributes?.picture,
          };

          setUserInfo(userInfo);

          if (userInfo?.token) {
            localStorage.setItem("jwtToken", userInfo.token);
          }

          cb();
        }
      })
      .catch(() => {
        //
      });
  });

  return {
    getUserInfo,
    userInfoContext,
    userInfoContextValue,
    userInfoContextInit,
  };
};

export default useUserInfo;
